import dayjs, { Dayjs } from "utils/dayjs"
import AmountWithCurrency, { IAmountWithCurrencyDto } from "./AmountWithCurrency"

export interface IGetDepreciationDto {
    periodFrom: string
    remainingDuration: number
    additions: IAmountWithCurrencyDto
    depreciationAmount: IAmountWithCurrencyDto
    bookValue: IAmountWithCurrencyDto
    taxBasedDeduction?: IAmountWithCurrencyDto | null
    extraordinaryDepreciation: IAmountWithCurrencyDto
    depreciationInvoiced?: IAmountWithCurrencyDto | null
    specialDepreciation?: IAmountWithCurrencyDto | null
    specialDepreciationComment?: string | null
    isBookingPeriod: boolean
    isSpecialDepreciationEditable: boolean
    splitOccured: boolean
}

export default class Depreciation {
    periodFrom: Dayjs
    remainingDuration: number
    additions: AmountWithCurrency
    depreciationAmount: AmountWithCurrency
    bookValue: AmountWithCurrency
    taxBasedDeduction: AmountWithCurrency
    extraordinaryDepreciation: AmountWithCurrency
    depreciationInvoiced?: AmountWithCurrency
    specialDepreciation: AmountWithCurrency
    specialDepreciationComment?: string
    isBookingPeriod: boolean
    isSpecialDepreciationEditable: boolean
    splitOccured: boolean

    constructor(dto: IGetDepreciationDto) {
        this.periodFrom = dayjs(dto.periodFrom, "YYYY-MM-DD") // take only date ignoring the time
        this.remainingDuration = dto.remainingDuration
        this.additions = new AmountWithCurrency(dto.additions)
        this.depreciationAmount = new AmountWithCurrency(dto.depreciationAmount)
        this.bookValue = new AmountWithCurrency(dto.bookValue)
        this.taxBasedDeduction = dto.taxBasedDeduction
            ? new AmountWithCurrency(dto.taxBasedDeduction)
            : new AmountWithCurrency({ amount: 0, currency: dto.depreciationAmount.currency })
        this.extraordinaryDepreciation =  new AmountWithCurrency(dto.extraordinaryDepreciation)
        this.depreciationInvoiced = dto.depreciationInvoiced ? new AmountWithCurrency(dto.depreciationInvoiced) : undefined
        this.specialDepreciation = dto.specialDepreciation
            ? new AmountWithCurrency(dto.specialDepreciation)
            : new AmountWithCurrency({ amount: 0, currency: dto.depreciationAmount.currency })
        this.specialDepreciationComment = dto.specialDepreciationComment ?? undefined
        this.isBookingPeriod = dto.isBookingPeriod
        this.isSpecialDepreciationEditable = dto.isSpecialDepreciationEditable
        this.splitOccured= dto.splitOccured
    }
}
